<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Start New Chat</v-card-title>

    <v-card-text>
        <m-autocomplete-phone-number
            v-model="endpoint"
            :organization_id="organization_id"
            
        />


        <v-text-field
            label="Message"
            v-model="text"
            ref="text"
            @keydown.enter="$event.preventDefault(); onOk();"
            autocomplete="off"
        />
        

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },
    },
    
    data() {
        return {
            dialog: false,
            endpoint: null,
            text: ''
        }
    },

    methods: {
        showDialog() 
        {
            this.endpoint = null;
            this.text = '';
            this.dialog = true;    
        },
        
        onOk()
        {
           this.dialog = false;

           let message = {
               'to': this.endpoint.value,
               'text': this.text,
           };

           this.$emit('send-text-to-start-chat', message);
        }
    },

    computed: {
        valid()
        {
            if ( this.text.length == 0 ) return false;
            if ( this.endpoint == null ) return false;
            return true;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>